'use client';

import { ServiceBase } from './ServiceBase';

/**
 * Authentication service
 * Handles login, token refresh
 */
export class AuthService extends ServiceBase {
  constructor() {
    super({
      endpoint: 'auths',
    });
  }

  /**
   * Create session (login)
   * @param username - Username or email
   * @param password - Password
   * @returns Access token and refresh token
   */
  createSession(username: string, password: string): Promise<{ accessToken: string; refreshToken: string }> {
    return this.post<{ accessToken: string; refreshToken: string }>(
      {
        userName: username,
        password,
      },
      {
        endpoint: '/createSession',
      },
    );
  }

  /**
   * Renew/refresh access token
   * @param token - Current token
   * @returns New access token
   */
  renewToken(token: string): Promise<string> {
    return this.post<string>(
      { token },
      {
        endpoint: '/refresh',
      },
    );
  }
}

export const authService = new AuthService();
